export const translations = {
  en: {
    // Nav & Section Keys
    Intro: "Andrea Iacolare",
    Experience: "Experience",
    Education: "Education",
    Skills: "Skills",
    TechStack: "Tech Stack",
    Projects: "Projects",
    Contact: "Contact",
    
    // Status & Hero
    AvailableForWork: "Available for new projects & opportunities",
    HeroGreeting: "Hi, I'm",
    IntroText: "Full-Stack & AI Developer specializing in modern React interfaces, fast web applications, and intuitive user experiences.",
    ViewProjects: "Explore Projects",
    ContactMe: "Get in Touch",
    CopyEmail: "Copy Email",
    EmailCopied: "Email copied to clipboard!",
    
    // Social & Contact
    Email: "Email",
    Instagram: "Instagram",
    LinkedIn: "LinkedIn",
    GitHub: "GitHub",
    
    // Section Titles & Subtitles
    ExperienceTitle: "Experience & Education",
    SkillsTitle: "Technical Skills & Arsenal",
    ProjectsTitle: "Featured Projects",
    ProjectsSubtitle: "A showcase of web applications and digital platforms crafted with modern technologies.",
    ContactTitle: "Let's Build Something Great",
    ContactSubtitle: "Feel free to reach out for collaborations, project inquiries, or just to say hi.",
    
    // Project Card
    LiveDemo: "Live Demo",
    SourceCode: "Source Code",
    Featured: "Featured Project",
    
    // Skills
    Languages: "Spoken Languages",
    Programming: "Development & Web",
    Tools: "Tools & Environment",

    // Misc
    GoodMorning: "Good Morning",
    GoodAfternoon: "Good Afternoon",
    GoodEvening: "Good Evening",
    DockPosition: "Dock Position",
    DockBottom: "Bottom Dock",
    DockLeft: "Left Vertical Dock",
    DockRight: "Right Vertical Dock",
    
    // Bento & Stats
    StatExperience: "Continuous Learning",
    StatExperienceVal: "2+ Yrs",
    StatProjects: "Production Apps",
    StatProjectsVal: "Featured",
    StatTech: "Core Stack",
    StatTechVal: "React & Node",
    StatFocus: "Specialization",
    StatFocusVal: "Full-Stack & AI",
    
    // Terminal / Code Window
    CodeWindowTitle: "andrea-profile.ts",
    CodeWindowTab1: "Profile.ts",
    CodeWindowTab2: "TechStack.json",
    CodeWindowTab3: "Terminal",

    // Information View Modes & Story Card
    ViewModeVisual: "Visual Card (Simple)",
    ViewModeCode: "Code View (Developer)",
    AboutTitle: "About Me & Profile Summary",
    AboutRole: "Full-Stack Web & AI Developer",
    AboutSummary: "I design and build high-performance websites, modern web applications, and intuitive digital tools. I manage both the frontend user experience and reliable backend systems.",
    WhatIDoTitle: "Areas of Expertise",
    WhatIDo1Title: "Modern Websites & Web Apps",
    WhatIDo1Desc: "Fast, responsive interfaces crafted with React, ensuring smooth mobile & desktop experiences.",
    WhatIDo2Title: "AI & Smart Automations",
    WhatIDo2Desc: "Integrating conversational AI, intelligent agents, and automated workflows into digital products.",
    WhatIDo3Title: "Robust Backend & APIs",
    WhatIDo3Desc: "Clean application logic, database management, and scalable server endpoints.",

    // Settings Modal
    Settings: "Settings",
    SettingsTitle: "Preferences & Customization",
    SettingsSubtitle: "Customize the theme, language, and dock position to your liking.",
    ThemeTitle: "Visual Theme",
    ThemeDark: "Dark Mode (Obsidian)",
    ThemeLight: "Light Mode (Porcelain)",
    LangTitle: "Interface Language",
    LangIT: "Italiano (Italian)",
    LangEN: "English (Inglese)",
    DockLayoutTitle: "Navigation Dock Position",
    DockTip: "Tip: You can also drag & drop the dock directly to any screen edge!",
    SettingsClose: "Close",
    ActiveBadge: "Active"
  },
  it: {
    // Nav & Section Keys
    Intro: "Andrea Iacolare",
    Experience: "Esperienze",
    Education: "Formazione",
    Skills: "Competenze",
    TechStack: "Tecnologie",
    Projects: "Progetti",
    Contact: "Contatti",
    
    // Status & Hero
    AvailableForWork: "Disponibile per nuovi progetti e collaborazioni",
    HeroGreeting: "Ciao, sono",
    IntroText: "Full-Stack & AI Developer specializzato nella realizzazione di interfacce React moderne, applicazioni web veloci ed esperienze digitali intuitive.",
    ViewProjects: "Esplora i Progetti",
    ContactMe: "Contattami",
    CopyEmail: "Copia Email",
    EmailCopied: "Email copiata negli appunti!",
    
    // Social & Contact
    Email: "Email",
    Instagram: "Instagram",
    LinkedIn: "LinkedIn",
    GitHub: "GitHub",
    
    // Section Titles & Subtitles
    ExperienceTitle: "Esperienza & Formazione",
    SkillsTitle: "Competenze Tecniche & Stack",
    ProjectsTitle: "Progetti Selezionati",
    ProjectsSubtitle: "Una selezione di applicazioni web e piattaforme realizzate con tecnologie all'avanguardia.",
    ContactTitle: "Mettiamoci in Contatto",
    ContactSubtitle: "Hai un'idea o vuoi collaborare? Scrivimi pure tramite email o attraverso i miei canali social.",
    
    // Project Card
    LiveDemo: "Visita Sito",
    SourceCode: "Codice",
    Featured: "In Evidenza",
    
    // Skills
    Languages: "Lingue Parlate",
    Programming: "Sviluppo & Web",
    Tools: "Strumenti & Ambiente",

    // Misc
    GoodMorning: "Buongiorno",
    GoodAfternoon: "Buon Pomeriggio",
    GoodEvening: "Buonasera",
    DockPosition: "Posizione Dock",
    DockBottom: "Dock in Basso",
    DockLeft: "Dock Verticale a Sinistra",
    DockRight: "Dock Verticale a Destra",
    
    // Bento & Stats
    StatExperience: "Apprendimento Continuo",
    StatExperienceVal: "2+ Anni",
    StatProjects: "Progetti Attivi",
    StatProjectsVal: "In Evidenza",
    StatTech: "Stack Principale",
    StatTechVal: "React & Node",
    StatFocus: "Specializzazione",
    StatFocusVal: "Full-Stack & AI",

    // Terminal / Code Window
    CodeWindowTitle: "andrea-profile.ts",
    CodeWindowTab1: "Profilo.ts",
    CodeWindowTab2: "TechStack.json",
    CodeWindowTab3: "Terminale",

    // Settings Modal
    Settings: "Impostazioni",
    SettingsTitle: "Preferenze & Personalizzazione",
    SettingsSubtitle: "Personalizza tema grafico, lingua e posizione della barra di navigazione.",
    ThemeTitle: "Tema Visivo",
    ThemeDark: "Modalità Scura (Ossidiana)",
    ThemeLight: "Modalità Chiara (Porcellana)",
    LangTitle: "Lingua Interfaccia",
    LangIT: "Italiano",
    LangEN: "English (Inglese)",
    DockLayoutTitle: "Posizione Barra di Navigazione (Dock)",
    DockTip: "Suggerimento: puoi anche trascinare la dock tenendo premuto con il mouse e rilasciandola sul bordo dello schermo!",
    SettingsClose: "Chiudi",
    ActiveBadge: "Attivo",

    // Information View Modes & Story Card
    ViewModeVisual: "Scheda Visiva (Semplice)",
    ViewModeCode: "Vista Codice (Tech)",
    AboutTitle: "Chi Sono & Sintesi Profilo",
    AboutRole: "Full-Stack Web & AI Developer",
    AboutSummary: "Progetto e sviluppo siti web ad alte prestazioni, applicazioni web moderne e strumenti digitali su misura. Mi occupo sia dell'aspetto visivo e dell'usabilità sia della logica interna e dei database.",
    WhatIDoTitle: "Cosa posso fare per te",
    WhatIDo1Title: "Siti & Applicazioni Web Complete",
    WhatIDo1Desc: "Interfacce veloci, moderne e ottimizzate per smartphone e computer realizzate in React.",
    WhatIDo2Title: "AI & Automazioni Intelligenti",
    WhatIDo2Desc: "Integrazione di modelli AI, assistenti virtuali e flussi di lavoro automatizzati.",
    WhatIDo3Title: "Backend Stabile & Database",
    WhatIDo3Desc: "Logiche applicative sicure, gestione dati e API veloci per far funzionare ogni servizio."
  }
};

